import React, { useRef, useEffect, useState } from "react"
import CustomLink from "./CustomLink"
import { isLinkEnabled, setNonDispalyValue } from "./EventHandler"

const DownloadLinkTable = (props) => {
   const [data, setData] = useState();
   const [previousData, setPreviousData] = useState();
   const [partName] = useState(props.partName)

   useEffect(() => {
      if (props.data) {
         setData(props.data);
      }
      if (props.previousData) {
         setPreviousData(props.previousData);
      }
   }, [props.data, props.previousData]);

   const [changeOccure, setChangeOccure] = useState(false)

   useEffect(() => {
      if (changeOccure) {
         const delay = setTimeout(() => {
            props.handleDiffCategory(props.name);
         }, 1000); // Add a 1-second delay
   
         // Cleanup the timeout to avoid memory leaks
         return () => clearTimeout(delay);
      }
   }, [changeOccure, props.name, props.handleDiffCategory]);

   const containerRef = useRef(null)
   const table1Ref = useRef(null)
   const table2Ref = useRef(null)

   useEffect(() => {
      const synchronizeRowHeights = () => {
         const table1Rows = table1Ref.current?.querySelectorAll("tr") || []
         const table2Rows = table2Ref.current?.querySelectorAll("tr") || []

         // Ensure both tables have the same number of rows
         const rowCount = Math.min(table1Rows.length, table2Rows.length)

         for (let i = 0; i < rowCount; i++) {
            const table1Row = table1Rows[i]
            const table2Row = table2Rows[i]

            // Get the maximum height of the two rows
            const maxHeight = Math.max(table1Row.offsetHeight, table2Row.offsetHeight)

            // Apply the maximum height to both rows
            table1Row.style.height = `${maxHeight}px`
            table2Row.style.height = `${maxHeight}px`
         }
      }

      // Synchronize row heights initially
      synchronizeRowHeights()

      // Synchronize row heights on window resize
      window.addEventListener("resize", synchronizeRowHeights)

      return () => {
         window.removeEventListener("resize", synchronizeRowHeights)
      }
   }, [data,previousData])

   useEffect(() => {
      let isSyncing = false

      const handleScrollTable1 = () => {
         if (isSyncing) return
         isSyncing = true
         if (table2Ref.current) {
            table2Ref.current.scrollTop = table1Ref.current.scrollTop || 0
            table2Ref.current.scrollLeft = table1Ref.current.scrollLeft || 0
         }
         isSyncing = false
      }

      const handleScrollTable2 = () => {
         if (isSyncing) return
         isSyncing = true
         if (table1Ref.current) {
            table1Ref.current.scrollTop = table2Ref.current.scrollTop || 0
            table1Ref.current.scrollLeft = table2Ref.current.scrollLeft || 0
         }
         isSyncing = false
      }

      const table1 = table1Ref.current
      const table2 = table2Ref.current

      if (table1) {
         table1.addEventListener("scroll", handleScrollTable1)
      }

      if (table2) {
         table2.addEventListener("scroll", handleScrollTable2)
      }

      return () => {
         if (table1) {
            table1.removeEventListener("scroll", handleScrollTable1)
         }
         if (table2) {
            table2.removeEventListener("scroll", handleScrollTable2)
         }
      }
   }, [data,previousData])

   const getHeader = (headerData = []) => {
      var keys = getKeys(headerData)

      return keys.map((key, index) => {
         if (setNonDispalyValue(key)) {
            return null
         }
         if (key.toLowerCase() === "zcsurl") {
            return <th key={key}></th>
         }
         return (
            <th key={key}>
               <span>{key}</span>
            </th>
         )
      })
   }

   const getKeys = (keysInformation = []) => {
      return Object.keys(keysInformation)
   }
   const getColumnKeys = (columKeyInfo) => {
      return Object.keys(columKeyInfo)
   }

   const RenderColumn = (props) => {
      return props.keys.map((key, index) => {
         if (props.data[key] !== "" && props.data[key] != null)
            return (
               <div key={index}>
                  <span className={props.isbold ? "bomFontClass" : ""}>{key}:</span>{" "}
                  <span>{props.data[key]}</span>
               </div>
            )
         else return null
      })
   }

   const compareObjects = (current, previous, parentKey = "") => {
      let differences = {}

      if (
         typeof current === "object" &&
         current !== null &&
         typeof previous === "object" &&
         previous !== null
      ) {
         // If both are objects, compare their keys recursively
         const keys = new Set([...Object.keys(current), ...Object.keys(previous)])
         keys.forEach((key) => {
            if (key.toLowerCase() === "zcsurl"){
               return
            }
            const newKey = parentKey ? `${parentKey}.${key}` : key // Flatten the key
            Object.assign(
               differences,
               compareObjects(current[key], previous[key], newKey)
            )
         })
      } else {
         // For primitive values, compare directly
         const flattenedKey = parentKey
         differences[flattenedKey] = current === previous ? "same" : "different"
      }

      return differences
   }

   const updateZcsURL = (obj) => {
      // Check if all values (except ZcsURL) are empty
      const isEmpty = Object.entries(obj).every(([key, value]) => {
          if (key.toLowerCase() === "zcsurl") {
              return true; // Skip ZcsURL from the check
          }
          if (typeof value === "object" && value !== null) {
              // Recursively check nested objects
              return updateZcsURL(value);
          }
          return !value; // Check if the value is empty or falsy
      });
  
      // If all other values are empty, set ZcsURL to false
      if (isEmpty) {
          obj.ZcsURL = false;
      }
  
      return obj;
  };

   const isObjectEmpty = (oldObj) => {
      const obj = updateZcsURL(oldObj)
      return Object.values(obj).every((value) => {
        if (typeof value === "object" && value !== null) {
            // Recursively check nested objects
            return isObjectEmpty(value);
        }
        return !value; // Check if the value is empty or falsy
      });
   };

   const differencesInEachRow = (index) => {
      let differencesInRow = {}
      // Ensure both rows exist

      if (!isObjectEmpty(data[index]) && !isObjectEmpty(previousData[index])) {
         differencesInRow = compareObjects(data[index], previousData[index])
      }

      return differencesInRow
   }

   const areBothTablesEmpty = () => {
      const updatedData = updateZcsURL(data)
      const isCurrDataEmpty =
         !updatedData ||
         updatedData.length === 0 ||
         updatedData.every((row) => {
            return Object.values(row).every((value) => {
               if (typeof value === "object" && value !== null) {
                  return Object.values(value).every((subValue) => !subValue)
               }
               return !value
            })
         })
      
      const updatedPrevData = updateZcsURL(previousData)
      const isPreviousDataEmpty =
         !updatedPrevData ||
         updatedPrevData.length === 0 ||
         updatedPrevData.every((row) => {
            return Object.values(row).every((value) => {
               if (typeof value === "object" && value !== null) {
                  return Object.values(value).every((subValue) => !subValue)
               }
               return !value
            })
         })

      return isCurrDataEmpty && isPreviousDataEmpty
   }

   const getRowsData = (tableData) => {
      var items = tableData
      var keys = getKeys(tableData[0])
      let backgroundColor = ""

      return items.map((row, index) => {

         const currRow = updateZcsURL(row)
         const isRowEmpty =
            !currRow ||
            Object.values(currRow).every((value) => {
               if (typeof value === "object" && value !== null) {
                  // Check if sub-object is empty
                  return Object.values(value).every((subValue) => !subValue)
               }
               return !value // Check if the value itself is empty
            })

         if (isRowEmpty && !areBothTablesEmpty()) {
            // Render an empty row
            if (changeOccure == false) {
               setChangeOccure(true)
               props.handleDiffCategory(props.name)
            }
            return (
               <tr key={index}>
                  <td colSpan={keys.length} style={{ backgroundColor: "#ffcccc" }}></td>
               </tr>
            )
         }
         if (areBothTablesEmpty()) {
            return (
               <tr key={index}>
                  <td colSpan={keys.length} style={{ backgroundColor: "white" }}></td>
               </tr>
            )
         }
         let differencesInRow = differencesInEachRow(index)

         if (Object.values(differencesInRow).includes("different")) {
            if (changeOccure == false) {
               setChangeOccure(true)
               props.handleDiffCategory(props.name)
            }
            backgroundColor = "#ffcccc"
         } else {
            backgroundColor = "white"
         }
         
         return (
            <tr key={index} style={{ backgroundColor: backgroundColor }}>
               <RenderRow
                  key={index}
                  data={row}
                  keys={keys}
                  differencesInRow={differencesInRow}
               />
            </tr>
         )
      })
   }
   const RenderLinkColumn = function (props) {
      return props.keys.map((key, index) => {
         if (
            props.data[key] &&
            props.data["id"] &&
            props.data["id"].toLowerCase().trim() !== "no access" &&
            key.toLowerCase().trim() === "name"
         ) {
            let name = props.data[key]

            return (
               <div key={index} style={{ minWidth: "9rem" }}>
                  <span>
                     {props.data["link"] ? (
                        <CustomLink
                           id={props.data["id"]}
                           link={props.data["link"]}
                           name={name}
                        />
                     ) : (
                        <span>{name}</span>
                     )}
                  </span>
               </div>
            )
         } else if (props.data[key] && setNonDispalyValue(key)) {
            return null
         }

         // else if (props.data[key])
         else if (props.data[key] != null)
            return (
               <div key={index}>
                  <span>{props.data[key]}</span>
               </div>
            )
         else return null
      })
   }

   const RenderRow = (props) => {
      return props.keys.map((key, index) => {
         if (
            props.data[key] != null &&
            typeof props.data[key] === "object" &&
            isLinkEnabled(key)
         ) {
            let colKeys = getColumnKeys(props.data[key])
            return (
               <td key={index}>
                  <RenderLinkColumn
                     isbold={true}
                     id={props.data["id"]}
                     link={props.data["link"]}
                     data={props.data[key]}
                     keys={colKeys}
                  />
               </td>
            )
         }
         if (props.data[key] != null && typeof props.data[key] === "object") {
            var colKeys = getColumnKeys(props.data[key])
            return (
               <td key={index}>
                  <RenderColumn data={props.data[key]} isbold={true} keys={colKeys} />
               </td>
            )
         } else if (
            (key.toLowerCase() === "name" || key.toLowerCase() === "document name") &&
            props.data["id"] &&
            props.data["id"].toLowerCase().trim() !== "no access"
         ) {
            var name = props.data[key]
            return (
               <td style={{ minWidth: "9rem" }} key={index}>
                  {props.data["link"] && props.data["link"] !== "" && props.data["id"] ? (
                     <CustomLink
                        id={props.data["id"]}
                        link={props.data["link"]}
                        name={name}
                     />
                  ) : (
                     <span>{name}</span>
                  )}
               </td>
            )
         }
         if (key.toLowerCase() === "zcsurl") {
         } else if (setNonDispalyValue(key)) {
            return null
         } else {
            if (props.differencesInRow[key] === "different") {
               return (
                  <td key={index} style={{ color: "red", fontWeight: "bold" }}>
                     {props.data[key]}
                  </td>
               )
            }
            return <td key={index}>{props.data[key]}</td>
         }
      })
   }

   return (
      <div className="tableFixHead">
         <>
            <div ref={containerRef} style={{ display: "flex" }}>
               <div
                  ref={table1Ref}
                  style={{ width: "50%", overflow: "auto", maxHeight: "60vh" }}
               >
                  <div
                     style={{
                        position: "sticky",
                        top: "0",
                        backgroundColor: "#EEEEEE",
                        textAlign: "center",
                        fontWeight: "bold",
                     }}
                  >
                     {partName}{" "}{props.revision["releaseRevision"]}
                  </div>
                  {data && data.length > 0 && (
                     <table className="tableBorder">
                        <thead
                           style={{
                              visibility:
                                 props.isHeader !== "false" ? "visible" : "collapse",
                           }}
                        >
                           <tr style={{backgroundColor:"#eee"}}>{getHeader(data[0])}</tr>
                        </thead>
                        <tbody>{getRowsData(data)}</tbody>
                     </table>
                  )}
               </div>

               <div
                  ref={table2Ref}
                  style={{ width: "50%", overflow: "auto", maxHeight: "60vh" }}
               >
                  <div
                     style={{
                        position: "sticky",
                        top: "0",
                        backgroundColor: "#EEEEEE",
                        textAlign: "center",
                        fontWeight: "bold",
                     }}
                  >
                     {partName}{" "}{props.revision["obsoleteRevision"]}
                  </div>
                  {previousData && previousData.length > 0 && (
                     <table className="tableBorder">
                        <thead
                           style={{
                              visibility:
                                 props.isHeader !== "false" ? "visible" : "collapse",
                           }}
                        >
                           <tr style={{backgroundColor:"#eee"}}>{getHeader(previousData[0])}</tr>
                        </thead>
                        <tbody>{getRowsData(previousData)}</tbody>
                     </table>
                  )}
               </div>
            </div>
         </>
      </div>
   )
}
export default DownloadLinkTable
